import React, { Component } from 'react';
import ModalHeader from './TableModalHeader';
import ModalBody from './TableModalBody';
import ModalFooter from './TableModalFooter';
import Pagination from '../TableRecord/Pagination';
import SearchRecord from '../../../Components/UI/TableRecord/SearchRecord';
import Modal from "react-bootstrap/Modal";
import { isSet } from '../../../Utils/CommonFunctions';
import Buttons from '../Buttons';

class TableModal extends Component {
    constructor(props) {
        super(props);
        this.state ={
            // isModalOpen:this.props.isModalOpen,
            // fade:this.props.isModalOpen,
            // buttonList:this.props.buttonList
        }
    }
    componentDidUpdate(prevProps){
        // if(prevProps.isModalOpen !== this.props.isModalOpen || prevProps.buttonList !== this.props.buttonList) {
        //   this.setState({isModalOpen: this.props.isModalOpen, buttonList:this.props.buttonList});
        //   setTimeout(() => {
        //     this.setState({fade: this.props.isModalOpen});
        //   }, 100);
        // }
    }
    render () {
        const {buttonList,Title,isModalOpen} = this.props;
        // const isShowModalCss = (this.state.isModalOpen) ? "block":"none";
        // const isShowModal = (this.state.fade) ? "show":"hide";
        // const maxWidth = (this.props.maxWidth)? this.props.maxWidth:"";
        //style={(this.props.style)?this.props.style:""}
        return (
            <>
            <Modal show={isModalOpen}  onHide={()=>{}} size="fullscreen table-modal-fullwidth">
                <div className="table_Box dataTables_wrapper">
                
                <div className="table_Header bg-white">
                    
                    
                    <div className="d-flex align-items-center justify-content-between"> 
                    <div className="title d-flex align-items-center justify-content-center">
                        <div className=""> {isSet(Title,this.props.title)} </div>
                        
                    </div>
                    {/* <ModalHeader Title={isSet(Title,this.props.title)} buttonList={[]} /> */}
                    
                        <div className="dataTables_length d-flex align-items-center">
                        
                            {(this.props.selectedMultiLookupCount>0)?
                                <label className="pl-0"><span className="badge badge-warning p-1"> {this.props.selectedMultiLookupCount}</span> {this.props.windowName} Selected</label>
                            :''}
                        </div>
                        <div className='d-flex align-items-center'>
                        <div className='btn-group'>
                            <Buttons buttonList={buttonList} />
                        </div>
                        {(this.props.isConfirmPage===false)?
                            <SearchRecord {...this.props} {...this.props.tableRecords.pagination} appendClass={"p-2"}/> 
                        :''}
                        </div>
                    </div>

                </div>
                {/* </Modal.Header> */}
                
                    <div className="table_Body p-0">
                        <ModalBody 
                            {...this.props} />
                    </div>
                <div className="table_Footer">
                    <Pagination {...this.props.tableRecords.pagination} {...this.props} />
                    <ModalFooter buttonList={this.props.FooterButtonList}/>
                </div>
                </div>
            </Modal>    
            {/* <div style={{display:isShowModalCss}}>
                <div  className={["modal","fade","lookUp_Pop",isShowModal].join(" ")}  tabIndex="-1" role="dialog" aria-labelledby="staticModalLabel" style={{display:'block',zIndex: '1042'}}  aria-hidden="true" data-backdrop="static" data-keyboard="false">
                    <div className="view" style={{"overflow":"inherit"}}>
                            
                        <div className="table_Box dataTables_wrapper">
                            
                            <ModalHeader Title={Title} buttonList={buttonList} />
                            <div className="table_Header bg-white">

                                <div className="d-flex align-items-center justify-content-between">
                                    
                                            
                                    <div className="dataTables_length">
                                        {(this.props.selectedMultiLookupCount>0)?
                                            <label className="pl-0"><span className="badge badge-warning p-1"> {this.props.selectedMultiLookupCount}</span> {this.props.windowName} Selected</label>
                                        :''}
                                    </div>
                                            
                                    
                                    {(this.props.isConfirmPage===false)?
                                        <SearchRecord {...this.props} {...this.props.tableRecords.pagination} appendClass={"p-2"}/> 
                                    :''}
                                </div>

                            </div>

                            <div className="table_Body p-0">
                                <ModalBody 
                                    {...this.props}
                                />
                            </div>

                            <div className="table_Footer">
                                
                                <Pagination {...this.props.tableRecords.pagination} {...this.props} 
                                />

                                <ModalFooter buttonList={this.props.FooterButtonList}/>

                            </div>

                        </div>
                        
                    </div>
                </div>

                <div className={["modal-backdrop","fade",isShowModal].join(" ")} style={{zIndex: '1030'}}></div> 
            </div> */}
            
            </>
            
            
        )
    }
}
TableModal.defaultProps = {
    preChildren: false,
  }
export default TableModal;


